import React, {useEffect} from "react"
import {Route, Routes} from "react-router-dom"
import {withLazyComponent} from "./lazyComponent"
import {protectedRoute} from "./protectedRoute"
import {publicRoute} from "./publicRoute"
import {useRecoilState, useRecoilValue} from "recoil"
import {globalBrandModuleSettingState, globalEWalletSettingState, globalUserDetailState, globalUserVerifyState} from "../_common/global_state"
import Layouts from "../layouts"

const Page404 = withLazyComponent(React.lazy(() => import("../pages/_error/page404")))
const PageNotVerify = withLazyComponent(React.lazy(() => import("../pages/_error/pageNotVerify")))

const RouterComponent = () => {
    const userVerifyState = useRecoilValue(globalUserVerifyState)
    const brandWebModuleSetting = useRecoilValue(globalBrandModuleSettingState)
    const userDetailState = useRecoilValue(globalUserDetailState)
    const eWalletSetting = useRecoilValue(globalEWalletSettingState);

    const filteredModule = []
    if (eWalletSetting?.depositWithKyc) {
        filteredModule.push("Deposit")
    }

    if (eWalletSetting?.withdrawalWithKyc) {
        filteredModule.push("Withdrawal")
    }

    const isKycKybVerified = userDetailState?.isKycApproved || userDetailState?.isKybApproved
    return (
        <Routes>
            {userVerifyState && (
                <Route path="/" element={<Layouts />}>
                    {protectedRoute &&
                        protectedRoute.map((item, index) => {
                            const moduleSetting = brandWebModuleSetting?.find((module) => module?.name === item?.moduleName)
                            const moduleEnabled = moduleSetting ? moduleSetting?.isEnabled : true
                            // const moduleEnabled = true;
                            let routeElement = <item.element />
                            if (filteredModule.includes(item?.name) && !isKycKybVerified) {
                                routeElement = <PageNotVerify />
                            }

                            return moduleEnabled ? <Route key={index} path={item?.path} element={routeElement} /> : null
                        })}
                    <Route path="*" element={<Page404 />} />
                </Route>
            )}

            <Route path="/">
                {publicRoute &&
                    publicRoute.map((item, index) => {
                        return <Route key={index} path={item?.path} element={<item.element />} />
                    })}
            </Route>
        </Routes>
    )
}

export default RouterComponent
